const uatConfig = {
  BASE_PATH: 'https://uat.sadhguru.org',
  FACADE_BASE_PATH: 'https://uat-iso-facade.sadhguru.org',
  YOUTH_OFFER_PATH: 'https://staging.innerengineering.com',
  PS_MENU_API:
    'https://apiuat.ishafoundation.org/scheduleApi/data.php?task=psmenu',
  PS_OVERSEAS_PRICING_API: 'https://online2.sadhguru.org/event/api/1/search',
  PS_PRICING_API: 'https://preprod-online.sadhguru.org/event/api/1/search',
  SCHEDULE_API_PATH: 'https://apiuat.ishafoundation.org/scheduleApi/api.php',
  SCHEDULE_DATA_API_PATH:
    'https://apiuat.ishafoundation.org/scheduleApi/data.php?task=preload',
  PROGRAMS_LIST_API_PATH:
    'https://apiuat.ishafoundation.org/scheduleApi/data.php?task=list',
  PROGRAMS_API_PATH: 'https://apiuat.ishafoundation.org/ishaapi/api/v1',
  LAT_LONG_API_PATH: 'https://uat-iso-facade.sadhguru.org/content/get-latlong/',
  IEO_SPT_URL:
    'https://staging.innerengineering.com/api/v3.0/course/support-details',
  HATHA_YOGA_PROGRAM_API_PATH: 'https://iso-hh-api.isha.in/iso_programs',
  FIND_A_TEACHER_API_PATH: 'https://iso-hh-api.isha.in/iso/teachers/finder/',
  HATHA_YOGA_REGISTRATION_FORM:
    'https://hys.isha.in/hys_portal/application/rest_api/user_register.php',
  IDY_REGISTRATION_FORM:
    'http://uat-iso-facade.sadhguru.org/content/subscription/add',
  CSR_PARTNERWITHUS_FORM: 'https://dev-api-ishangam.isha.in/rl_leads',
  HYTT_TALKTOALUMNI_FORM:
    'https://uat-iso-facade.sadhguru.org/content/subscription/add',
  SADHANAPADA_WEBINAR_REGISTRATION_FORM:
    'https://uat-iso-facade.sadhguru.org/content/bigmarker/webinar/register/iso',
  DONATE_API: 'https://apiuat.ishafoundation.org/ishaapi/api/v1/donate/offline',
  YOGA_MEDITATION_SAD_CAT:
    'https://preprod-online.sadhguru.org/event/api/search',
  MARGAZHI_SADHANA_REG_URL:
    'https://preprod-online.sadhguru.org/event-register?event=',
  GOY_PRICE_API:
    'https://uat-iso-facade.sadhguru.org/content/goy/get-program-info',
  SANNIDHI_PROGRAM_API:
    'https://uat-iso-facade.sadhguru.org/content/get-program-info?type=sannidhi',
  FYD_Program_API:
    'https://staging.innerengineering.com/schedule-api/v2.0/listing?page=1&category=any-category&daterange=any-date&fee=any-fee&type=any-type&invCategory=false&centerId=25&pgmTypeClassification=event&sortField=date&country=US&pgmTypeId=4',
  FREE_YOGA_DAY_REGISTRATION_FORM:
    'https://qa-prs.innerengineering.com/ieo/newadmin/api/events/rsvp',
  FREE_YOGA_DAY_UPDATED_REGISTRATION_FORM: 
    'https://staging.innerengineering.com/register-api/v2.0/events/rsvp',
  MMM_PROGRAM_API:
    'https://uat-iso-facade.sadhguru.org/content/get-program-info?type=mmm',
  PBK_PROGRAM_API:
    'https://uat-iso-facade.sadhguru.org/content/goy/get-program-info?type=pbk',
  YANTRAINLINEFORM:
    'https://preprod-inlineform-online.sadhguru.org/inline-form.bundle.js',
  ILAINLINEFORM:
    'https://preprod-inlineform-online.sadhguru.org/inline-form.bundle.js',
  USEXITPOPUPURL: 'https://innerengineering.sadhguru.org/lib/js/exit-popup.js',
  IEO_PRG_URL:
    'https://qa-prs.innerengineering.com/ieo/newadmin/api/ieo/ieoPgms',
  IEO_PRS_DOMAIN: 'https://staging.innerengineering.com',
  NEW_IEO_PRG_URL:
    'https://staging.innerengineering.com/register-api/v2.0/ie-7-steps/pricing-details',
  IEO_REGISTER_URL:
    'https://staging.innerengineering.com/register-api/v2.0/ie-7-steps/register',
  NEXT_PUBLIC_USPRS_API_URL:
    'https://qa-prs.innerengineering.com/ieo/newadmin/api',
  NEXT_PUBLIC_GEO_API_URL:
    'https://qa-innerengineering.sadhguru.org/edgeapi/region',
  IEO_VALIDATE_EMAIL_URL:
    'https://staging.innerengineering.com/register-api/v2.0/ie-7-steps/eligibility',
  IEO_COUPON_APPLY:
    'https://staging.innerengineering.com/register-api/v2.0/ie-7-steps/coupon/apply',
  NEXT_PUBLIC_GPMS_URL:
    'https://uat1-payment.sadhguru.org/api/ieprs/payment-request',
  NEXT_PUBLIC_IEO_LOGIN_URL:
    'https://staging.innerengineering.com/LANG/7-steps',
  IEO_PRE_SIGNED_UPLOAD_URL:
    'https://staging.innerengineering.com/register-api/v2.0/registration/upload-file/pre-signed-url',
  CLOUDFRONT_VIDEO_BUCKET_URL: 'https://dz8eesk2qtdx3.cloudfront.net',
  YOGA_SANDHYA_IYC_LINK:
    'https://preprod-online.sadhguru.org/event-register?event=yoga-sandhya-at-isha-yoga-center-917',
  YOGA_SANDHYA_SSB_LINK:
    'https://online.sadhguru.org/event-register?event=yoga-sandhya-901',
  LANGUAGE_UPGRADE_ELIGIBILITY:
    'https://staging.innerengineering.com/register-api/v2.0/ie-7-steps/language-upgrade-eligibility',
  UPGRADE_LANGUAGE:
    'https://staging.innerengineering.com/register-api/v2.0/ie-7-steps/upgrade-language',
  EOE_EVENT: 'https://preprod-facade-online.sadhguru.org',
  EOE_EVENT_DOMAIN: 'https://preprod-frontend-online.sadhguru.org',
  MSR_EVENT_DOMAIN: 'https://portal-online.sadhguru.org',
  MSR_EVENT_IN_ID: '13363',
  MSR_EVENT_OV_ID: '13640',
  IDY_PUSH: 'https://dev-api-ishangam.isha.in/rl_initiatives',
  PUSH_LEADS: 'https://dev-api-ishangam.isha.in',
  UPCOMING_INITIATION_DATE:
    'https://staging.innerengineering.com/api/v3.0/course/upcoming-initiation-dates',
  STATE_FROM_PINCODE:
    'https://cdi-gateway.isha.in/contactinfovalidation/api/countries',
  EMAIL_LOGIN_URL:
    'https://staging.innerengineering.com/en/7-steps/public/landing?choose_login_option=password&login_hint=[EMAIL]&disable_autologin=1',
  MY_PROFILE_URL: 'https://uat-sso.isha.in',
  SCHEDULE_WOB__PROGRAM_API_PATH:
    'https://apiuat.ishafoundation.org/scheduleApi/data.php?task=iewlist',
  SULABHA_PATH: 'https://qa-sulaba.isha.in/api/sulaba',
  COOKIE_DOMAIN: '.sadhguru.org',
  ENV_NAME: 'uat',
  SHORT_ENV_NAME: 'uat',
  IS_LOG: false,
  USE_LOCAL_URL: false,
  BUILD_URLS: {
    HOME: {
      lvl0: [],
      enabled: false,
    },
    SADHGURU: {
      lvl0: [],
      wisdom: {
        L1: [],
        L2: [],
      },
      enabled: false,
    },
    WISDOM: {
      /* lvl0: ['/en/wisdom/'], */
      wisdom: {
        L1: [],
        L2: [],
      },
      enabled: false,
    },
    HEALTH: {
      lvl0: ['/en/health'],
      health: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    CENTER: {
      lvl0: ['/en/center'],
      health: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    YM: {
      lvl0: [],
      'yoga&meditation': {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    EVENTS: {
      lvl0: [],
      events: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    OTHERS: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    DONATION: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    VOLUNTEER: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    NEWS: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    OUTREACH: {
      lvl0: [],
      other_pages: {
        L1: [],
        L2: [],
        L3: [],
      },
      enabled: false,
    },
    MSR: {
      lvl0: [],
      home_page: ['/mahashivratri/'],
      mahashivratri_child: {
        L1: [],
        L2: [],
      },
      enabled: false,
    },
    LANDING_PAGES: {
      // will build these landing pages if it is set to true
      YantraCeremony: false,
      SadhguruExclusive: false,
      SadhguruExclusiveRenew: false,
      SadhguruExclusiveEvent: false,
      SadhguruExclusiveTrial: false,
      SadhguruSannidhi: false,
      ShivangaLanding: false,
      Sadhanapada: false,
      GOY: false,
      IEO: false,
      MYY: false,
      Nagapratishta: false,
      RudrakshaDiksha: false,
      SubscribeFailure: true,
      SubscribeConfirm: true,
    },
  },
  USA_PROG_API:
    'https://staging.innerengineering.com/schedule-assets/js/embed-v1.0.js',
  RECAPTCHA_KEY: '6LcjOCwaAAAAAE9OCSYsf2JJYsWjYr7iWAof6B4_',
  MIXPANEL_TOKEN: '8f2198148dc13f47cf0c85c4698370f2',
  MIXPANEL_TOKEN_US: '8dbbf48dc1d4d0a4031dd1fe6d849132',
  MIXPANEL_DEBUG: true,
  REGISTER_TR_API_URL: 'https://uat-prs-eu-api.sadhguru.org/admin/events',
};

export default uatConfig;
